import { API } from '@/api'
import { BaseModule, EventBus } from '@mc/tangram-core'

const t2str = value => (value > 9 ? `${value}` : `0${value}`)

const mill2hms = mills => {
  const htime = 60 * 60 * 1000
  const mtime = 60 * 1000
  const stime = 1000

  const h = Math.floor(mills / htime)
  mills = mills - h * htime

  const m = Math.floor(mills / mtime)
  mills = mills - m * mtime

  const s = Math.floor(mills / stime)

  return {
    hour: t2str(h),
    minute: t2str(m),
    sec: t2str(s)
  }
}

export const SecKillStatus = {
  notStart: 1,
  hasStart: 2,
  finish: 3
}

export const SecKillLayoutType = {
  basic: 'basic',
  promotion: 'promotion'
}

export class Seckill extends BaseModule {
  id = ''

  name = 'seckill'

  events = {
    click: 'click',
    addCart: 'add-cart',
    subscribeArriveNotice: 'subscribe-arrive-notice',
    countDown: 'count-down',
    goSpike: 'go-spike'
  }

  EventBus = new EventBus()

  constructor(options) {
    super(options)
    this.id = options.id
    this.layoutType = options.layoutType || SecKillLayoutType.basic
    this.serverTime = options.data[0].serverTime * 1000
    this.showCountDown = options.data[0].serverTime !== -1
    this.startTime = options.data[0].startTime * 1000
    this.endTime = options.data[0].endTime * 1000
    this.clientTime = Date.now()
    if (this.startTime - this.serverTime > 0) {
      this.secKillStatus = SecKillStatus.notStart
    } else if (this.endTime - this.serverTime > 0) {
      this.secKillStatus = SecKillStatus.hasStart
    } else {
      this.secKillStatus = SecKillStatus.finish
    }
    this.data = {
      countDownText: options.style.countDownText,
      rows: options.data[0].rows,
      action: options.rawOptions.action
    }
    this.countDownTip =
      this.layoutType === SecKillLayoutType.promotion
        ? options.style.promoteCountDownText
        : options.style.countDownText
    this.countDownStyle = this.formatStyle({
      backgroundImage: `url(${
        options.style.titleImg && options.style.titleImg.img_url
      })`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left center'
    })
    this.countDownTextStyle = this.formatStyle({
      color: options.style.cornerFontColor || '#ffffff',
      backgroundColor: options.style.cornerBgColor || '#ff6200'
    })
    this.countDownSepStyle = this.formatStyle({
      color: options.style.cornerFontColor || '#ffffff'
    })
    this.countDownTipStyle = this.formatStyle({
      color: options.style.cornerBgColor || '#444444',
      fontSize: this.valueCalc(22),
      lineHeight: this.valueCalc(0),
      marginRight: this.valueCalc(10)
    })
  }

  moduleRefresh() {
    const requestTime =
      this.secKillStatus === SecKillStatus.notStart
        ? this.startTime
        : this.endTime
    const timeRange = requestTime - this.serverTime
    const delay = Math.floor(Math.random() * timeRange)
    setTimeout(async () => {
      if (!this.pageId) return
      const res = await API.cms.getById({
        pageid: this.pageId,
        moduleids: `${this.id}`,
        currentseckilltime: requestTime / 1000
      })
      if (res && res.page_data) {
        this.cache = res
      }
    }, delay)
  }

  preLoadModule() {
    if (this.countDownTimer) {
      clearTimeout(this.countDownTimer)
    }
    if (this.cache) {
      this.globalEventBus.emit(this.globalEvents.UPDATE_MODULE, {
        moduleId: this.id,
        data: this.cache
      })
    } else {
      this.globalEventBus.emit(this.globalEvents.DELETE_MODULE, {
        moduleId: this.id
      })
    }
  }

  countDown() {
    if (this.secKillStatus === SecKillStatus.finish) {
      return
    }
    if (this.countDownTimer) {
      clearTimeout(this.countDownTimer)
    }
    const time =
      this.secKillStatus === SecKillStatus.notStart
        ? this.startTime
        : this.endTime
    const totalTime = time - this.serverTime
    if (
      !totalTime ||
      totalTime - (new Date().getTime() - this.clientTime) <= 0
    ) {
      return
    }
    this.sessionHour = new Date(time).getHours()

    const func = () => {
      const diff = Date.now() - this.clientTime
      const currDiff = totalTime - diff
      if (currDiff < 100) {
        this.preLoadModule()
        return
      }
      const hms = mill2hms(Math.max(currDiff, 0))
      this.postMessage(this.events.countDown, hms)
      this.countDownTimer = setTimeout(func, 800)
    }

    func()
  }

  render() {
    if (this.showCountDown) {
      this.countDown()
      this.moduleRefresh()
    }
    const {
      id,
      containerStyle,
      countDownStyle,
      countDownTextStyle,
      countDownSepStyle,
      countDownTip,
      countDownTipStyle,
      layoutType,
      serverTime,
      clientTime,
      startTime,
      endTime,
      secKillStatus,
      data,
      events,
      globalEvents,
      showCountDown
    } = this
    return {
      id,
      renderIdentifier: 'seckill',
      containerStyle,
      countDownStyle,
      countDownTextStyle,
      countDownSepStyle,
      countDownTip,
      countDownTipStyle,
      serverTime,
      clientTime,
      startTime,
      endTime,
      secKillStatus,
      data,
      layoutType,
      events,
      globalEvents,
      showCountDown
    }
  }
}
